export default {
    title: 'Quick search',
    placeholder: 'Search customers, templates, pages…',
    cancel: 'Cancel',
    groups: {
        recent: 'Recent customers',
        clients: 'Customers',
        actions: 'Actions',
        pages: 'Pages',
        dietPlans: 'Diet plan templates',
        recipes: 'Recipes',
    },
    actions: {
        newClient: 'New customer',
        newClientHint: 'Quick add',
        newAppointment: 'New appointment',
        aCloud: 'Open aCloud',
    },
    allClients: 'All customers matching “{query}” ({count})',
    searching: 'Searching…',
    noResults: {
        title: 'Nothing found for “{query}”',
        hint: 'Try a customer’s name, mobile or email, or the name of a page.',
    },
    keys: {
        navigate: 'move',
        open: 'open',
        close: 'close',
    },
}
